import { useContext, useEffect, useState } from "react";
import { Col, OverlayTrigger, Row, Tooltip } from "react-bootstrap";
import UECard from "../UECard";
import ModalPopup from "../ModalPopup";
import { readCurrentState, sendCurrentState, StepContext } from "../StepContext";
import pagoPa from "../../img/loghi-pagopa_Io.png";

import img_bollettino from "../../img/bollettino-pagopa.png";
import img_domiciliazione from "../../img/domiciliazione.png";
import useQuery from "../../hooks/useQuery";
import { validaCodiceFiscale } from "./Step1";


var msgText = '';
var msgTitle = '';

var readURLParams = true;

function isValidIBANNumber(input) {
    var CODE_LENGTHS = {
        AD: 24, AE: 23, AT: 20, AZ: 28, BA: 20, BE: 16, BG: 22, BH: 22, BR: 29,
        CH: 21, CR: 21, CY: 28, CZ: 24, DE: 22, DK: 18, DO: 28, EE: 20, ES: 24,
        FI: 18, FO: 18, FR: 27, GB: 22, GI: 23, GL: 18, GR: 27, GT: 28, HR: 21,
        HU: 28, IE: 22, IL: 23, IS: 26, IT: 27, JO: 30, KW: 30, KZ: 20, LB: 28,
        LI: 21, LT: 20, LU: 20, LV: 21, MC: 27, MD: 24, ME: 22, MK: 19, MR: 27,
        MT: 31, MU: 30, NL: 18, NO: 15, PK: 24, PL: 28, PS: 29, PT: 25, QA: 29,
        RO: 24, RS: 22, SA: 24, SE: 24, SI: 19, SK: 24, SM: 27, TN: 24, TR: 26,
        AL: 28, BY: 28, CR: 22, EG: 29, GE: 22, IQ: 23, LC: 32, SC: 31, ST: 25,
        SV: 28, TL: 23, UA: 29, VA: 22, VG: 24, XK: 20
    };
    var iban = String(input).toUpperCase().replace(/[^A-Z0-9]/g, ''), // keep only alphanumeric characters
        code = iban.match(/^([A-Z]{2})(\d{2})([A-Z\d]+)$/), // match and capture (1) the country code, (2) the check digits, and (3) the rest
        digits;
    // check syntax and length
    if (!code || iban.length !== CODE_LENGTHS[code[1]]) {
        return false;
    }
    // rearrange country code and check digits, and convert chars to ints
    digits = (code[3] + code[1] + code[2]).replace(/[A-Z]/g, function (letter) {
        return letter.charCodeAt(0) - 55;
    });
    // final check
    return mod97(digits) === 1;
}

function mod97(string) {
    var checksum = string.slice(0, 2), fragment;
    for (var offset = 2; offset < string.length; offset += 7) {
        fragment = String(checksum) + string.substring(offset, offset + 7);
        checksum = parseInt(fragment, 10) % 97;
    }
    return checksum;
}

function Step4() {
    let query = useQuery();

    const [modalShow, setModalShow] = useState(false);

    const [modPagamento, setModPagamento] = useState("");
    const [dd_intestatario, setDd_intestatario] = useState("");
    const [dd_sottoscrittore, setDd_sottoscrittore] = useState("");
    const [cf_intestatario, setCf_intestatario] = useState("");
    const [cf_sottoscrittore, setCf_sottoscrittore] = useState("");
    const [dd_IBAN, setDd_IBAN] = useState("");


    const { step, setStep } = useContext(StepContext);


    useEffect(() => {

        //console.log("step: " + step);

        if (readURLParams || (step < 4)) {

            let nc = readCurrentState('nome').trim() + ' ' + readCurrentState('cognome').trim() + ' ' + readCurrentState('ragionesoc').trim()
            setDd_sottoscrittore(nc.trim().toUpperCase());
            setCf_sottoscrittore(readCurrentState('cofi').toUpperCase())

            MostraDatiGet();
            readURLParams = false;
        } else {
            MostraDatiLocalStorage();
        }



    }, []);


    function MostraDatiGet() {
        //console.log("MostraDatiGet");

        if (query.has("modP")) {
            let modP = query.get("modP");
            if (modP === "R") {
                setModPagamento("R");
            } else if (modP === "D") {
                setModPagamento("D");
            }
        }
    }

    function MostraDatiLocalStorage() {
        //console.log("MostraDatiLocalStorage");

        let modP = readCurrentState("modPagamento");
        if (modP === "R") {
            setModPagamento("R");
        } else if (modP === "D") {
            setModPagamento("D");
        }
        setDd_intestatario(StepContext.contratto.dd_intestatario);
        setCf_intestatario(StepContext.contratto.dd_CFIntestatarioCC);
        setDd_sottoscrittore(StepContext.contratto.dd_sottoscrittoreDD);
        setCf_sottoscrittore(StepContext.contratto.dd_CFSottoscrittoreSDD);
        setDd_IBAN(StepContext.contratto.dd_IBAN);
    }

    const activeOption = (f) => {
        let active = "ue btn btn-q btn-yellow active_f";
        let noactive = "ue btn btn-q btn-yellow";

        if ((f == 'R') && (modPagamento === 'R')) {
            return active;
        } else if ((f == 'D') && (modPagamento === 'D')) {
            return active;
        } else {
            return noactive;
        }
    }

    function copiaDaSottoscrittore() {
        setDd_intestatario(dd_sottoscrittore);
        setCf_intestatario(cf_sottoscrittore);
    }

    function ModuloRimessaDiretta() {
        return <>
            <br />
            <p style={{ margin: "0 100px", textAlign: "center", fontSize: "small" }}>
                Se scegli il pagamento con <b>bollettino PagoPa</b>, puoi dimenticare la scadenza
                della fattura. E' sempre consigliabile l'attivazione della domiciliazione bancaria
                per non avere pensieri ed essere sempre puntuale.
                <br /><br />
                Avrai sempre la garanzia di poterla revocarla in qualsiasi momento e di chiedere
                lo storno del pagamento alla tua banca in caso di contestazione.</p>
            <hr />
            <h3 style={{ margin: "0 auto", maxWidth: "800px", textAlign: "center" }}>
                Per saperne di più visita il sito di PagoPa e scarica l'app IO

                <a href="https://www.pagopa.gov.it/" target="_blank"><img src={pagoPa} style={{ marginTop: "25px" }}></img></a>
            </h3>


        </>
    }

    function ModuloDomiciliazione() {
        return <>
            <br />
            <p style={{ margin: "0 10px", textAlign: "center", fontSize: "small" }}>
                Grazie per aver scelto di pagare con la <b>domiciliazione bancaria!</b><br />
                Con questa modalità sarai sempre puntuale e non avrai la preoccupazione di
                pagare alla scadenza.
                <br /><br />
                Avrai sempre la garanzia di poterla revocare in qualsiasi momento e di chiedere
                lo storno del pagamento alla tua banca in caso di contestazione.</p>
            <hr />
            <h2>Inserisci i tuoi dati di domiciliazione</h2>

            <div style={{ margin: "10px auto", maxWidth: "300px", textAlign: "left", paddingLeft: "15px" }}>

                <Row>
                    <Col>
                        <label htmlFor="intes">
                            Sottoscrittore*<br />
                            <input type="text" className="ue ue-text" id="intes" placeholder="Nome e Cognome del sottoscrittore"
                                maxLength="70" value={dd_sottoscrittore} onChange={(e) => { setDd_sottoscrittore(e.target.value.toUpperCase()) }} />
                        </label>
                    </Col>
                    <Col>
                        <label htmlFor="intes">
                            Codice Fiscale Sottoscrittore*<br />
                            <input type="text" className="ue ue-text" id="intes" placeholder="Codice Fiscale sottoscrittore"
                                maxLength="16" value={cf_sottoscrittore} onChange={(e) => { setCf_sottoscrittore(e.target.value.toUpperCase()) }} />
                        </label>
                    </Col>
                </Row>
                <br />
                <Row>
                    <Col>
                        <label htmlFor="intes">
                            Intestatario del conto*<br />
                            <input type="text" className="ue ue-text" id="intes" placeholder="Nome e Cognome dell'intestatario"
                                maxLength="70" value={dd_intestatario} onChange={(e) => { setDd_intestatario(e.target.value.toUpperCase()) }} />
                        </label>
                    </Col>
                    <Col>
                        <label htmlFor="intes">
                            Codice Fiscale Intestatario*<br />
                            <input type="text" className="ue ue-text" id="intes" placeholder="Codice Fiscale dell'intestatario"
                                maxLength="16" value={cf_intestatario} onChange={(e) => { setCf_intestatario(e.target.value.toUpperCase()) }} />
                        </label>
                    </Col>
                </Row>
                <br />
                <button className="ue btn btn-green" style={{ textAlign: "center" }} onClick={copiaDaSottoscrittore}>
                    <small>L'intestatario è uguale al sottoscrittore</small>
                </button>
                <br /><br />
                <Row>
                    <Col>
                        <label htmlFor="iban">
                            IBAN*<br />
                            <input type="text" className="ue ue-text" id="iban" placeholder="Codice IBAN"
                                maxLength="30" value={dd_IBAN} onChange={(e) => { setDd_IBAN(e.target.value.toUpperCase()) }} />
                        </label>
                    </Col>
                </Row>
            </div>
        </>
    }

    function VisualizzaModulo() {
        if (modPagamento === "R")
            return ModuloRimessaDiretta()
        if (modPagamento === "D")
            return ModuloDomiciliazione()
    }


    function disabilitaTastiTipoPagamento(f) {
        if (query.has("modP")) {
            if ((f == "R") && (modPagamento == "D")) {
                return true;
            } else
                if ((f == "D") && (modPagamento == "R")) {
                    return true;
                }
        }
    }


    function Validation() {
        let conx = {};

        if (modPagamento === "") {
            msgText = 'Seleziona la modalità con cui preferisci pagare le fatture';
            msgTitle = 'Informazioni non valide o mancanti';
            setModalShow(true);
            return false;
        }

        if (modPagamento === "D") {
            if (dd_intestatario.trim().length < 5) {
                msgText = "Inserisci nome e cognome dell'intestatario del conto sul quale verranno addebitate le fatture.";
                msgTitle = 'Informazioni non valide o mancanti';
                setModalShow(true);
                return false;
            }
            if (dd_sottoscrittore.trim().length < 5) {
                msgText = "Inserisci nome e cognome del sottoscrittore per il conto sul quale verranno addebitate le fatture.";
                msgTitle = 'Informazioni non valide o mancanti';
                setModalShow(true);
                return false;
            }
            if (dd_IBAN.trim().length === 0) {
                msgText = "Inserisci il codice IBAN del conto sul quale verranno addebitate le fatture.";
                msgTitle = 'Informazioni non valide o mancanti';
                setModalShow(true);
                return false;
            }
            if (!isValidIBANNumber(dd_IBAN)) {
                msgText = "Il codice IBAN inserito non sembra essere corretta, verifica i dati inseriti oppure richiedi il pagamento con bollettino PagoPa. Potrai modificare la tua scelta una volta attivato il contratto.";
                msgTitle = 'Informazioni non valide o mancanti';
                setModalShow(true);
                return false;
            }

            if ((cf_intestatario.trim().length != 16) && (cf_intestatario.trim().length != 11)&& (cf_intestatario.trim().length != 8)) {
                msgText = "Inserire un codice fiscale di 8 o 16 cifre valido per l'intestatario";
                msgTitle = 'Informazioni non valide o mancanti';
                setModalShow(true);
                return false;
            }
            if ((cf_intestatario.trim().length == 16)&&(!validaCodiceFiscale(cf_intestatario.trim()))){
                //console.log(cf_intestatario.trim());
                msgText = 'Il codice fiscale dell\'intestatario inserito non è valido, verifica che non ci siano errori';
                msgTitle = 'Informazioni non valide o mancanti';
                setModalShow(true);
                return false;
            }            
            if ((readCurrentState("pf")==true)&&(cf_sottoscrittore.trim().length != 16)) {
                msgText = "Inserire un codice fiscale valido per il sottoscrittore";
                msgTitle = 'Informazioni non valide o mancanti';
                setModalShow(true);
                return false;
            }
            if ((cf_sottoscrittore.trim().length == 16)&&(!validaCodiceFiscale(cf_sottoscrittore.trim()))){
                msgText = 'Il codice fiscale del sottoscrittore inserito non è valido, verifica che non ci siano errori';
                msgTitle = 'Informazioni non valide o mancanti';
                setModalShow(true);
                return false;
            }

            if(readCurrentState("pf")==false){
                if (cf_intestatario.trim() != readCurrentState("cofi")){
                    msgText = "Per la domiciliazione l'intestatario del conto bancario deve coincidere con l'intestatario del contratto";
                    msgTitle = 'Informazioni non valide o mancanti';
                    setModalShow(true);
                    return false;
                }
            }

            conx = {
                step: step,
                modPagamento: modPagamento,
                dd_intestatario: dd_intestatario.trim(),
                dd_sottoscrittoreDD: dd_sottoscrittore.trim(),
                dd_CFSottoscrittoreSDD: cf_sottoscrittore.trim(),
                dd_CFIntestatarioCC: cf_intestatario.trim(),
                dd_IBAN: dd_IBAN.trim()
            };

        } else if (modPagamento === "R") {
            conx = {
                step: step,
                modPagamento: modPagamento
            };
        } else {
            msgText = 'Seleziona la modalità con cui preferisci pagare le fatture';
            msgTitle = 'Informazioni non valide o mancanti';
            setModalShow(true);
            return false;
        }

        StepContext.contratto = { ...StepContext.contratto, ...conx };
        sendCurrentState();

        return true;
    }

    return (
        <UECard BackButton={true} NextButton={true} className="S1Div" style={{ marginLeft: "250px", width: "100%", textAlign: "center", marginTop: "50px" }} onValidate={Validation}>
            <h2 style={{ color: "green" }}><b>Come pago le Fatture?</b></h2>
            <h2>Scegli la modalità che preferisci</h2>
            <Row className="justify-content-center" style={{ display: 'flex' }} >
                <Col className="text-center text-md-right">
                    <OverlayTrigger overlay={disabilitaTastiTipoPagamento("R") ? <Tooltip id="tooltip-disabled1">L'offerta selezionata non prevede la scelta del pagamento con PagoPa, se vuoi pagare con PagoPa contatta il Servizio Clienti</Tooltip> : <Tooltip style={{ visibility: "hidden" }} />}>
                        <span className="d-inline-block">
                            <button id="f_g" className={activeOption("R")} onClick={() => { setModPagamento('R'); }} disabled={disabilitaTastiTipoPagamento("R")}><span><img src={img_bollettino}></img></span><br />BOLLETTINO PagoPa</button>
                        </span>
                    </OverlayTrigger>
                    <OverlayTrigger overlay={disabilitaTastiTipoPagamento("D") ? <Tooltip id="tooltip-disabled1">L'offerta selezionata non prevede la scelta del pagamento con Domiciliazione, se vuoi attivare la domiciliazione bancaria contatta il Servizio Clienti</Tooltip> : <Tooltip style={{ visibility: "hidden" }} />}>
                        <span className="d-inline-block">
                            <button id="f_e" className={activeOption("D")} onClick={() => { setModPagamento('D'); }} disabled={disabilitaTastiTipoPagamento("D")}><span><img src={img_domiciliazione}></img></span><br />DOMICILIAZIONE BANCARIA</button>
                        </span>
                    </OverlayTrigger>
                </Col>
            </Row>
            {VisualizzaModulo()}

            <ModalPopup title={msgTitle} message={msgText} show={modalShow} onHide={() => setModalShow(false)} />

        </UECard>

    );
}

export default Step4